import { STATIC_IMAGES } from "utils/url.utils";

export const getCountryFlagUrl = (countryCode: string): string => {
  const code = countryCode.trim().toLowerCase();
  if (!code) {
    return "";
  }
  return `${STATIC_IMAGES}/Icons/flags/${code}.svg`;
};
